/* import __COLOCATED_TEMPLATE__ from './refer-a-friend.hbs'; */
import { computed } from '@ember/object';
import Component from '@ember/component';
import { emailValidator } from '../utils/validators';
import { handleFormErrorOrModal } from 'sh-www/utils/handles-errors';

/** @module */
const ReferAFriendComponent = Component.extend({
  /** @inheritDoc */
  tagName: '',

  /** @type {string} */
  name: '',

  /** @type {Ember.ComputedProperty} */
  nameValidator: computed('name', function() {
    const name = this.get('name');
    if (!name) return 'This is a required field';
    if (name.length < 5) return 'The name must be at least 5 characters long';
  }),

  /** @type {string} */
  email: '',

  /** @type {Ember.ComputedProperty} */
  emailValidator: computed('email', function() {
    const email = this.get('email');
    if (!email) return 'This is a required field';
    return emailValidator(email);
  }),

  /** @type {boolean} */
  submitting: false,

  /** @inheritDoc */
  init() {
    this._super(...arguments);
    this.set('errors', { });
  },

  /** @inheritDoc */
  actions: {
    /**
     * @param {string} field
     * @param {InputEvent} e
     */
    updateField(field, e) {
      this.setProperties({ [field]: e.target.value, [`errors.${field}`]: undefined });
    },

    /**
     * @param {string} field
     * @param {string} validator
     */
    validateField(field, validator) {
      const error = this.get(validator);

      if (error) {
        this.set(`errors.${field}`, error);
      }
    },

    /**
     * @param {Event} e
     */
    preventSubmit(e) {
      e.preventDefault();
    },

    /**
     *
     */
    cancel() {
      this.get('close')();
    },

    /**
     *
     */
    submit() {
      if (this.get('submitting') || !this._validateForm()) {
        return;
      }

      const { name, email } = this.getProperties(['name', 'email']);

      this.set('submitting', true);
      this.get('onsubmit')(name, email).catch((e) => {
        this.set('submitting', false);

        handleFormErrorOrModal(
          this,
          e,
          ['name', 'email'],
          false,
          'There was an error sending your referral. Please refresh and try again.',
          'referAFriendError -- error sending user referral' + JSON.stringify(e)
        );
      });
    },
  },

  /**
   * @returns {boolean}
   * @private
   */
  _validateForm() {
    const [errors, hasError] = ['name', 'email'].reduce(([errors, hasError], field) => {
      const err = this.get(`${field}Validator`);

      if (err) {
        errors[field] = err;
        hasError = true;
      }

      return [errors, hasError];
    }, [{ }, false]);

    this.set('errors', errors);
    return !hasError;
  },
});

export default ReferAFriendComponent;
